import {
    createGlobalLanguageSlice,
    makeglobalLanguageSelectors,
    LanguageSupportConfig,
} from 'optimized-react-component-library-xyz123'
import data from '../content/content.application.json'
import type { RootState } from './store'

const { LanguageSupport: globalLanguageContent } = data as { LanguageSupport: LanguageSupportConfig }

export const globalLanguageSlice = createGlobalLanguageSlice(globalLanguageContent, { name: 'globalLanguageContent' })

export default globalLanguageSlice.reducer

export const { setActivatedLanguage, setGlobalLangauage } = globalLanguageSlice.actions

const selectors = makeglobalLanguageSelectors<RootState>((state: any) => state.applicationContent)

/**
 * Selector som returnerar det språk som användaren för närvarande har valt
 * (activatedLanguage). Används som huvudkälla för att styra vilket språk
 * formulärets texter ska laddas på.
 */
export const selectActivatedLanguage = selectors.selectActivatedLanguage
/**
 * Selector som returnerar true när den språkberoende globala språkfilen
 * (globalLanguage) har laddats.
 */
export const selectGlobalLanguageLoaded = selectors.selectGlobalLanguageLoaded
/**
 * Selector som returnerar hela globalLanguageState-objektet.
 */
export const selectGlobalLanguageState = selectors.selectGlobalLanguageState

export const selectGlobalLanguage = selectors.selectGlobalLanguage
